import React from "react";
import "../Style/Footer.css";
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin } from "react-icons/fa";
import { IoLocationSharp, IoCall } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./UserContext.js";

const Footer = () => {
  const { options } = useAuth();
  console.log("Option ", options.location);

  const { makeCall } = useAuth();
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section location-section">
          <div className="footer-icon-text">
            <IoLocationSharp className="footer-icon" />
            {options?.location?.map((loc) => (
              <p>{loc.locationName},</p>
            ))}
          </div>
          <div
            className="footer-icon-text"
            onClick={makeCall}
            style={{ cursor: "pointer" }}
          >
            <IoCall className="footer-icon" />
            <p>+919129371733</p>
          </div>
        </div>
        <div className="footer-sec-div">
          <div className="footer-section explore-section">
            <strong className="strong-text-footer">Explore</strong>
            <ul>
              <li onClick={() => navigate("/aboutus")}>About us</li>
              <li onClick={() => navigate("/contactus")}>Contact</li>
            </ul>
          </div>

          <div className="footer-section legal-section">
            <strong className="strong-text-footer">Legal</strong>
            <ul>
              <li onClick={() => navigate("/privacypolicy")}>Privacy Policy</li>
              <li onClick={() => navigate("/termandcondition")}>
                Terms of Service
              </li>
            </ul>
          </div>
          <div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14377.012363452628!2d82.67348628148906!3d25.729142668583187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39903b24bbaf2fa9%3A0x2bc47357bf08ed88!2sHomoeopathic%20Health%20Care%20%26%20Research%20Center!5e0!3m2!1sen!2sin!4v1763399507886!5m2!1sen!2sin"
              height="250"
              // style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          {/* <div className="footer-section subscribe-section">
            <strong className="strong-text-footer">Treatment</strong>
            <ul>
              <li>Kidney Diseases</li>
              <li>Kidney Stone</li>
              <li>Breast Tumor</li>
              <li>Acnes, Pimples</li>
            </ul>
          </div> */}
        </div>
      </div>
      {/* <div className="footer-links">
        <p>Cookie Policy/Settings</p>
        <p>Accessibility Statement</p>
        <p>Sitemap</p>
      </div> */}
      <div className="footer-divide-line"></div>
      <div className="footer-follow-text">
        {" "}
        <p>Follow Us On</p>
      </div>
      <div className="footer-bottom">
        <div className="footer-socials">
          <FaFacebook
            onClick={() =>
              window.open(
                "https://www.facebook.com/share/1C5fMj5wD9/",
                "_blank"
              )
            }
          />
          <FaInstagram
            onClick={() =>
              window.open(
                "https://www.instagram.com/drrkvishwakarma?utm_source=qr&igsh=MTN0cm54ejlyZG1vdw==",
                "_blank"
              )
            }
          />
          <FaXTwitter
            onClick={() =>
              window.open(
                "https://x.com/DrRKVishwakar12?t=OYjYZIfBc35pghI2SB596g&s=09",
                "_blank"
              )
            }
          />
          <FaYoutube
            onClick={() =>
              window.open(
                "https://youtube.com/@drrk-sn3hj?si=hP54NdYNzWuz-Esm",
                "_blank"
              )
            }
          />
          <FaLinkedin
            onClick={() =>
              window.open(" https://www.linkedin.com/groups/4361062/", "_blank")
            }
          />
        </div>
       
      </div>
      <div className="footer-copyright">
        <p>© 2024 All Rights Reserved.</p>
        <a href="https://www.netseems.com">
          Developed and Maintained by Netseems Ventures Pvt. Ltd.
        </a>
      </div>
    </footer>
  );
};

export default Footer;
